import React from 'react';
import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const faqs = [
  {
    q: 'Will this work for my business?',
    a: "If you're a local business — a restaurant, cafe, cloud kitchen, salon, or retail store — and you want more customers from Instagram, yes. Our system is specifically built for businesses like yours.",
  },
  {
    q: 'How long does it take to see results?',
    a: "Most businesses start seeing increased engagement within 2-3 weeks. Real customer growth typically kicks in within 60-90 days as the system builds momentum.",
  },
  {
    q: 'Do I need to create content myself?',
    a: "No. We handle the content strategy, scripting, and planning. We guide you on what to shoot, and if needed, we can connect you with content creators in your area.",
  },
  {
    q: 'Is this only for big brands?',
    a: "The opposite. Big Jaguar is built specifically for small and local businesses. You don't need a big budget or a big team. That's what we're here for.",
  },
  {
    q: "What if I've tried Instagram marketing before and it didn't work?",
    a: "Most businesses fail because they post without a system. Random posts, no strategy, no optimization. We build a complete growth system — that's the difference.",
  },
  {
    q: 'Do you handle influencer marketing too?',
    a: "Yes. We manage strategic influencer collaborations on Instagram that are designed to drive real foot traffic and orders — not just vanity exposure.",
  },
];

export const FAQSection = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.6 }}
            className="md:col-span-4"
          >
            <span className="font-accent text-slate-400 mb-4 block" data-testid="faq-label">
              FAQ
            </span>
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-slate-900 leading-tight"
              data-testid="faq-headline"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              Common{' '}
              <span className="font-medium">Questions</span>
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="md:col-span-8"
          >
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {faqs.map((faq, i) => (
                <AccordionItem
                  key={i}
                  value={`faq-${i}`}
                  className="border-slate-200"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger
                    className="text-left text-base font-medium text-slate-900 hover:no-underline py-5"
                    style={{ fontFamily: 'Outfit, sans-serif' }}
                    data-testid={`faq-trigger-${i}`}
                  >
                    {faq.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm text-slate-500 leading-relaxed pb-5">
                    {faq.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
